import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Debug logging for E2E troubleshooting (TD-050)
console.log('[SPECTREIQ] main.tsx executing...')
console.log('[SPECTREIQ] document.readyState:', document.readyState)
console.log('[SPECTREIQ] root element:', document.getElementById('root'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

try {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    console.error('[SPECTREIQ] FATAL: root element not found!')
  } else {
    console.log('[SPECTREIQ] Creating React root...')
    const root = ReactDOM.createRoot(rootElement)
    console.log('[SPECTREIQ] Rendering React app...')
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </React.StrictMode>,
    )
    console.log('[SPECTREIQ] React render() called successfully')
  }
} catch (error) {
  console.error('[SPECTREIQ] React render error:', error)
}
